import { selectorFamily } from "recoil";

import { popupAtom } from "../../popups/popupAtom";
import { gis2TokenAtom } from '../../login/loginAtoms.js'
import { selectedRegionUrlQuerySelector } from "../../map/selectedRegionAtoms";
import { layerDefsAtomFamily } from "../layerDefsAtoms";

export const layerDefSourceDataSelector = selectorFamily({
  key: "layer-source-data-selector",
  get:
    (layerID) =>
    ({ get }) => {
      const layerDef = get(layerDefsAtomFamily(layerID));
      const selectedRegionUrlQuery = get(selectedRegionUrlQuerySelector);
      const filterBySelectedRegion = layerDef.filterBySelectedRegion;

      if (filterBySelectedRegion && !selectedRegionUrlQuery) {
        return null;
      }

      if (layerDef.layer.type === "raster") {
        return layerDef.source.tiles[0];
      }

      let src = filterBySelectedRegion
        ? `${layerDef.source.data}&${selectedRegionUrlQuery}`
        : layerDef.source.data;

      if (typeof src === 'object') {
        return src
      }

      if (!src) {
        return null
      }

      if (!layerDef.requiresGis2Token) {
        return src
      }

      const token = get(gis2TokenAtom)
      if (!token) {
        return null
      }
      
      return `${src}&token=${token}`
    },
  set:
    (layerID) =>
    ({ set, get }, newData) => {
      const layerDef = get(layerDefsAtomFamily(layerID))
      if (layerDef.customFetch) {
        dismissPopup(set, layerID)
        setSourceData(set, layerDefsAtomFamily(layerID), newData)
      }
    }
});

function dismissPopup(set, layerID) {
  set(popupAtom, (oldPopup) => {
    if (oldPopup?.layerId === layerID) {
      return null;
    }
    return oldPopup;
  });
}

function setSourceData(set, layerDef, data) {
  set(layerDef, (oldLayer) => ({
    ...oldLayer,
    source: {
      ...oldLayer.source,
      data: data,
    },
  }))
}
